module.exports = __webpack_public_path__ + "static/media/proj15_img4.ca9961aa.jpg";